"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicContainer = void 0;
const React = __importStar(require("react"));
const ContainerLogic_1 = require("./ContainerLogic");
const constants_1 = require("./constants");
/** This is a shared dom structure for similar skins */
const BasicContainerComp = (_a, ref) => {
    var { classes } = _a, rest = __rest(_a, ["classes"]);
    return (React.createElement(ContainerLogic_1.ContainerLogic, Object.assign({}, rest, { ref: ref, className: classes.root, renderSlot: ({ containerChildren }) => (React.createElement(React.Fragment, null,
            React.createElement("div", { className: classes.bg, "data-testid": constants_1.TestIds.BG }),
            containerChildren)) })));
};
exports.BasicContainer = React.forwardRef(BasicContainerComp);
//# sourceMappingURL=BasicContainer.js.map